import { EuiEmptyPrompt, EuiText } from "@inscopix/ideas-eui";
import { ButtonCreateContainer } from "components/ButtonCreateContainer/ButtonCreateContainer";

export const PromptFirstCustomContainer = () => {
  return (
    <EuiEmptyPrompt
      title={<h2>Create your first custom container!</h2>}
      style={{ maxWidth: "100%" }}
      titleSize="xs"
      iconType="wrench"
      body={
        <p>
          <EuiText>
            All tools in IDEAS are run inside of containers. Use one of the
            provided containers or create your own to start running your tools.
          </EuiText>
        </p>
      }
      actions={[<ButtonCreateContainer key="create-container" filled />]}
    />
  );
};
